export const GET_SHORTLIST_MANAGERS_DATA_LIST="GET_SHORTLIST_MANAGERS_DATA_LIST"
export const GET_SHORTLIST_MANAGERS_DATA_LIST_SUCCESS="GET_SHORTLIST_MANAGERS_DATA_LIST_SUCCESS"
export const GET_SHORTLIST_MANAGERS_DATA_LIST_FAILED="GET_SHORTLIST_MANAGERS_DATA_LIST_FAILED"
export const ADD_SHORTLIST_MANAGER_M="ADD_SHORTLIST_MANAGER_M"
export const UPDATE_SHORTLIST_MANAGER="UPDATE_SHORTLIST_MANAGER"
export const GET_INTERVIEWERS_LIST="GET_INTERVIEWERS_LIST"
export const GET_INTERVIEWERS_LIST_SUCCESS="GET_INTERVIEWERS_LIST_SUCCESS"
export const GET_INTERVIEWERS_LIST_FAILED="GET_INTERVIEWERS_LIST_FAILED"
export const ADD_INTERVIEWER_M="ADD_INTERVIEWER_M"
export const UPDATE_INTERVIEWER_M="UPDATE_INTERVIEWER_M"
